import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared/shared.module';
import { NotificationPreferencesTypeOverviewPage } from './notification-preferences-type-overview.page';
import { NotificationPreferencesTypeOverviewPageRoutingModule } from './notification-preferences-type-overview-routing.module';
import { AlertGroupCardComponent } from './components/alert-group-card/alert-group-card.component';
import { ToggleAllToastComponent } from './components/toggle-all-toast/toggle-all-toast.component';
import { NotificationPreferencesModule } from '../notification-preferences.module';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    NotificationPreferencesTypeOverviewPageRoutingModule,
    SharedModule,
    NotificationPreferencesModule,
  ],
  declarations: [
    AlertGroupCardComponent,
    ToggleAllToastComponent,
    NotificationPreferencesTypeOverviewPage,
  ],
})
export class NotificationPreferencesTypeOverviewPageModule {}
